import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../../hook/use-http";
import NoData_Jupiter from "../NoData_Jupiter";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates";

function TableMainErc_Jupiter({ apiend, gloablfilter, title }) {
  const [tableDropDown, setTableDropDown] = useState("BMS");
  const [tableData, SetTableData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const changeDropDown = (e) => {
    setTableDropDown(e.target.value);
  };

  const appyData = (data) => {
    SetTableData(data[0]);
  };

  useEffect(() => {
    SetTableData([]);
    fetchData(
      {
        url: API_URL_MAIN + apiend,
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  const safeToFixed = (val, digits = 1) =>
    typeof val === "number" ? val.toFixed(digits) : 0;

  return (
    <>
      <div className="v-title tablebox drive_graph p-0">
        <div className="titlebg titlebd_drive box_title justify-content-between align-items-center d-flex pb-1 pt-1 d-flex justify-content-end pr-2 mb-0">
          <span className="text-start ml-2">ECU Stats</span>
          <select
            onChange={changeDropDown}
            value={tableDropDown}
            className="form-select dropdownSelect acc_select mt-0"
            id="discharge_load_first"
            name="discharge_load_first"
          >
            <option value="BCS">BCS</option>
            <option value="BMS">BMS</option>
            <option value="Motor">Motor</option>
            <option value="MCU">MCU</option>
            <option value="DCDC">DCDC</option>
             <option value="AC">AC</option>
          </select>
        </div>

        <div className="m-0 table-container">
          {tableData !== undefined ? (
            <>
              {Object.keys(tableData).length > 0 && tableData !== undefined ? (
                <>
                  <table className="table table-striped">
                    <thead
                      style={{
                        backgroundColor: "#358696",
                        color: "#fff",
                        position: "sticky",
                        top: 0,
                      }}
                    >
                      <tr>
                        <th scope="col">Parameter</th>
                        <th scope="col">Value</th>
                      </tr>
                    </thead>
                    {tableDropDown === "BCS" && (
                      <tbody>
                        <tr>
                          <td>Median BCS active time</td>
                          <td>
                            {tableData.Median_BCS_active_time?.values?.["50.0"] !== 0 ? safeToFixed(
                              tableData.Median_BCS_active_time?.values?.["50.0"],
                              1
                            ) + " min" : "--"}
                          </td>
                        </tr>
                        <tr>
                          <td>Median BCS active time percent</td>
                          <td>
                            {tableData.Median_BCS_active_time_percent?.values?.["50.0"] !== 0 ? safeToFixed(
                              tableData.Median_BCS_active_time_percent?.values?.["50.0"],
                              2
                            ) + " %" : "--"}
                          </td>
                        </tr>
                        <tr>
                          <td>Median BCS delta comp pressure</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_BCS_delta_comppressure?.values?.["50.0"],
                              2
                            )}{" "}
                            Bar
                          </td>
                        </tr>
                        <tr>
                          <td>Median BCS comp current</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_BCS_Comp_Current?.values?.["50.0"],
                              1
                            )}{" "}
                            A
                          </td>
                        </tr>
                         <tr>
                          <td>Median BCS  comp temperature</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_BCS_Comp_temperature?.value,
                              2
                            )}{" "}
                                 °C
                          </td>
                        </tr>
                        <tr>
                          <td>Max BCS comp temperature</td>
                          <td>
                            {safeToFixed(
                              tableData.Max_BCS_Comp_temperature?.value,
                              1
                            )}{" "}
                                 °C
                          </td>
                        </tr>
                        <tr>
                          <td>Median BCS Coolant In</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_BCS_coolant_In?.values?.["50.0"],
                              1
                            )}{" "}
                            °C
                          </td>
                        </tr>
                        <tr>
                          <td>Max BCS Coolant In</td>
                          <td>
                            {safeToFixed(
                              tableData.Max_BCS_coolant_In?.values?.["50.0"],
                              1
                            )}{" "}
                            °C
                          </td>
                        </tr>
                        <tr>
                          <td>Median BCS Coolant Out</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_BCS_coolant_Out?.values?.["50.0"],
                              1
                            )}{" "}
                            °C
                          </td>
                        </tr>
                        <tr>
                          <td>Max BCS Coolant Out</td>
                          <td>
                            {safeToFixed(
                              tableData.Max_BCS_coolant_Out?.values?.["50.0"],
                              1
                            )}{" "}
                            °C
                          </td>
                        </tr>
                        
                          
                      </tbody>
                    )}
                    {tableDropDown === "MCU" && (
                      <tbody>
                        <tr>
                          <td>Median MCU current</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_MCU_Current_Motoring?.values?.["50.0"],
                              1
                            )}{" "}
                            A
                          </td>
                        </tr>
                        <tr>
                          <td>Max MCU current</td>
                          <td>
                            {safeToFixed(
                              tableData.Max_MCU_Current_Motoring?.value,
                              1
                            )}{" "}
                            A
                          </td>
                        </tr>
                        <tr>
                          <td>Median MCU temperature</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_MCU_Temperature?.values?.["50.0"],
                              1
                            )}{" "}
                            °C
                          </td>
                        </tr>
                        <tr>
                          <td>Max MCU temperature</td>
                          <td>
                            {safeToFixed(
                              tableData.Max_MCU_Temperature?.value,
                              1
                            )}{" "}
                            °C
                          </td>
                        </tr>
                      </tbody>
                    )}
                    {tableDropDown === "DCDC" && (
                      <tbody>
                        {/* <tr>
                          <td>Median DCDC power day</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_DCDC_Output_Power_Day?.values?.["50.0"],
                              1
                            )}{" "}
                            kWh
                          </td>
                        </tr>
                        <tr>
                          <td>Max DCDC  power day</td>
                          <td>
                            {safeToFixed(
                              tableData.Max_DCDC_Output_Power_Day?.value,
                              1
                            )}{" "}
                            kWh
                          </td>
                        </tr> */}
                        <tr>
                          <td>Max DCDC temp </td>
                          <td>
                            {safeToFixed(
                              tableData.Max_DCDC_Temperature_2?.value,
                              1
                            )}{" "}
                            °C
                          </td>
                        </tr>
                        <tr>
                          <td>Median DCDC temp </td>
                          <td>
                            {safeToFixed(
                              tableData.Median_DCDC_Temperature_2?.values?.["50.0"],
                              1
                            )}{" "}
                            °C
                          </td>
                        </tr>
                        <tr>
                          <td>Median DCDC current day</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_DCDC_Output_Current_Day?.values?.["50.0"],
                              1
                            )}{" "}
                            A
                          </td>
                        </tr>
                        <tr>
                          <td>Max DCDC current day</td>
                          <td>
                            {safeToFixed(
                              tableData.Max_DCDC_Output_Current_Day?.value,
                              1
                            )}{" "}
                            A
                          </td>
                        </tr>
                        <tr>
                          <td>Median DCDC current night</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_DCDC_Output_Current_Night?.values?.["50.0"],
                              1
                            )}{" "}
                            A
                          </td>
                        </tr>
                        <tr>
                          <td>Max DCDC current night</td>
                          <td>
                            {safeToFixed(
                              tableData.Max_DCDC_Output_Current_Night?.value,
                              1
                            )}{" "}
                            A
                          </td>
                        </tr>

                      </tbody>
                    )}
                    {tableDropDown === "Motor" && (
                      <tbody>
                        <tr>
                          <td>Median torque</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_Torque_Forward_Motoring?.values?.["50.0"],
                              2
                            )}{" "}
                            Nm
                          </td>
                        </tr>
                        <tr>
                          <td>Median throttle</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_Throttle_Forward_Motoring?.values?.["50.0"],
                              0
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>Median RPM</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_RPM_Forward_Motoring?.values?.["50.0"],
                              0
                            )}{" "}
                            RPM
                          </td>
                        </tr>
                        {/* <tr>
                          <td>Median acceleration</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_Acceleration_Forward_Motoring?.values?.["50.0"],
                              3
                            )}{" "}
                            m/s*s
                          </td>
                        </tr> */}
                        <tr>
                          <td>Median speed</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_Vehicle_Speed_Forward_Motoring?.values?.["50.0"],
                              1
                            )}{" "}
                            m/s
                          </td>
                        </tr>
                        {/* <tr>
                          <td>Median Motor current</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_Motor_Current_Motoring?.values?.["50.0"],
                              1
                            )}{" "}
                            A
                          </td>
                        </tr> */}
                        {/* <tr>
                          <td>Max Motor current</td>
                          <td>
                            {safeToFixed(
                              tableData.Max_Motor_Current_Motoring?.value,
                              1
                            )}{" "}
                            A
                          </td>
                        </tr> */}
                      </tbody>
                    )}
                    {tableDropDown === "BMS" && (
                      <tbody>
                        <tr>
                          <td>Median (BMS Max cell temp)</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_BMS_Max_Cell_Temp?.values?.["50.0"],
                              1
                            )}{" "}
                            °C
                          </td>
                        </tr>
                        <tr>
                          <td>Max BMS Max cell temp</td>
                          <td>
                            {safeToFixed(
                              tableData.Max_BMS_Max_Cell_Temp?.value,
                              1
                            )}{" "}
                            °C
                          </td>
                        </tr>
                        <tr>
                          <td>Median (BMS Min cell temp)</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_BMS_Min_Cell_temp?.values?.["50.0"],
                              1
                            )}{" "}
                            °C
                          </td>
                        </tr>
                        <tr>
                          <td>Min BMS Min cell temp</td>
                          <td>
                            {safeToFixed(
                              tableData.Min_BMS_Min_Cell_Temp?.value,
                              1
                            )}{" "}
                            °C
                          </td>
                        </tr>
                        <tr>
                          <td>Median (BMS Max cell voltage)</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_BMS_Max_Cell_Voltage?.values?.["50.0"],
                              3
                            )}{" "}
                            V
                          </td>
                        </tr>
                        <tr>
                          <td>Max BMS Max cell voltage</td>
                          <td>
                            {safeToFixed(
                              tableData.Max_BMS_Max_Cell_Voltage?.value,
                              3
                            )}{" "}
                            V
                          </td>
                        </tr>
                        <tr>
                          <td>Median (BMS Min cell voltage)</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_BMS_Min_Cell_Voltage?.values?.["50.0"],
                              3
                            )}{" "}
                            V
                          </td>
                        </tr>
                        <tr>
                          <td>Min BMS Min cell voltage</td>
                          <td>
                            {safeToFixed(
                              tableData.Min_BMS_Min_Cell_Voltage?.value,
                              3
                            )}{" "}
                            V
                          </td>
                        </tr>
                        <tr>
                          <td>Median delta cell voltage</td>
                          <td>
                            {tableData.Median_Delta_Cell_Voltage?.values?.["50.0"] || 0}
                            mV
                          </td>
                        </tr>
                        <tr>
                          <td>Max delta cell voltage</td>
                          <td>
                            {tableData.Max_Delta_Cell_Voltage?.value || 0} mV
                          </td>
                        </tr>
                        <tr>
                          <td>Median BMS Pack current</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_BMS_Pack_Current?.values?.["50.0"],
                              1
                            )}{" "}
                            A
                          </td>
                        </tr>
                        
                        <tr>
                          <td>SOH</td>
                          <td>
                            {safeToFixed(tableData.Min_SOH?.value, 1)}
                          </td>
                        </tr>
                        
                      </tbody>
                      
                    )}
                     {tableDropDown === "AC" && (
                      <tbody>
                        <tr>
                          <td>Median AC Active time</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_AC_active_time?.values?.["50.0"],
                              1
                            )}{" "}
                            mins
                          </td>
                        </tr>
                        <tr>
                          <td>Median AC Active time %</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_AC_active_time_percent?.values?.["50.0"],
                              1
                            )}{" "}
                            %
                          </td>
                        </tr>
                        <tr>
                          <td>Median cabin temperature</td>
                          <td>
                            {safeToFixed(
                              tableData.Median_Cabin_temperature?.values?.["50.0"],
                              1
                            )}{" "}
                            °C
                          </td>
                        </tr>
                        <tr>
                          <td>Max cabin temperature</td>
                          <td>
                            {safeToFixed(
                              tableData.Max_Cabin_temperature?.values?.["50.0"],
                              1
                            )}{" "}
                            °C
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                </>
              ) : (
                <NoData_Jupiter />
              )}
            </>
          ) : (
            <NoData_Jupiter />
          )}
        </div>
      </div>
    </>
  );
}

export default TableMainErc_Jupiter;
